import { Link } from "react-router-dom";

import { KTSVG } from "../../../../../../_metronic/helpers";
import { formatHectares } from "../../../../../shared/numberFormat";
import { buildLandViewPath } from "../ViewLand/ViewLandContext";
import "./Land.style.scss";

const Land = ({ field, land }) => {
    return (
        <Link to={buildLandViewPath(field.field_id, land.land_id)} className="d-flex align-items-center p-5 land-item">
            <span className="bullet bullet-vertical h-40px bg-primary land-item__bullet"></span>
            <div className="flex-grow-1 land-item__content">
                <span className="text-gray-800 text-hover-primary fw-bold fs-6 land-item__name">{land.name}</span>
                <span className="text-muted fw-semibold d-block land-item__meta">{formatHectares(land.ha)}</span>
            </div>
            <span className="btn btn-sm btn-light-primary fs-8 fw-bold land-item__cta"><KTSVG path="/media/icons/duotune/arrows/arr024.svg" /></span>
        </Link>
    )
}

export default Land;
